<template>
  <div class="vip-mid-choice">
    <img class="head-banner-bg" src="./../../assets/img/head-banner-bg.jpg" />

    <div v-show="isOverlayVisible" class="over-lap"></div>
    <opt-dialog v-show="isOptDialogVisible" @consult="toConsult" @tel="toTel"></opt-dialog>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { lego } from '@zz-common/lego'

import OptDialog from './OptDialog/OptDialog'

const KEFU_TEL = '4006018080'

export default {
  name: 'VIPMidChoice',
  data() {
    return {
      isOptDialogVisible: true
    }
  },
  computed: {
    isOverlayVisible() {
      return this.isOptDialogVisible || false
    }
  },
  created() {
    native.setTitle({
      title: 'VIP客户服务'
    })

    lego.send({
      pagetype: 'ZZUP_VIPMIDCHOICE',
      actiontype: 'PAGE_SHOW'
    })
  },
  methods: {
    toTel() {
      lego.send({
        pagetype: 'ZZUP_VIPMIDCHOICE',
        actiontype: 'TEL_CLICK'
      })

      window.location.href = `tel:${KEFU_TEL}`
      native.close()
    },
    toConsult() {
      lego.send({
        pagetype: 'ZZUP_VIPMIDCHOICE',
        actiontype: 'CONSULT_CLICK'
      })

      native.skipToUrl({
        targetUrl: 'https://feentry.zhuanzhuan.com/kfzx_a?clientid=vipsp_a',
        needClose: '1'
      })
    }
  },
  components: {
    OptDialog
  }
}
</script>

<style lang="less" scoped>
  @import 'VIPMidChoice.less';
</style>
